import R from 'app/assets/R'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { SectionBase } from 'app/components/common/SectionBase'
import { useTable } from './hook'
import { FilterLayout } from './layouts'
import { BaseTableReport, HeadPageWrapper, RootWrapper } from './styles'
import { useVerifyPermissionAndRedirect } from 'app/common/use-verify-permission-redirect'
import {
  FunctionPermissionEnum,
  ModulePermissionEnum,
} from 'app/common/permission-module'

export const Report020Container = () => {
  const {
    filter,
    handleChangeFilter,
    data,
    columns,
    isLoading,
    handleTableChange,
    pagination,
    handleExportExcel,
  } = useTable()
  const { isHavePermissionFunction } = useVerifyPermissionAndRedirect()
  return (
    <RootWrapper>
      <HeadPageWrapper
        titleI18nKey={R.strings.report_20}
        isExport={isHavePermissionFunction(
          ModulePermissionEnum.REPORT,
          FunctionPermissionEnum.REPORT_EXPORT_REPORT_20,
        )}
        onPressExport={handleExportExcel}
      />
      <SectionBase>
        <BaseSpace>
          <FilterLayout formData={filter} onChange={handleChangeFilter} />

          <BaseTableReport
            columns={columns}
            dataSource={data}
            pagination={pagination}
            loading={isLoading}
            onChange={handleTableChange}
            rowClassName="row-overwrite-style"
            scroll={{
              x: true,
            }}
          />
        </BaseSpace>
      </SectionBase>
    </RootWrapper>
  )
}
